// ============================================================================
// بيانات "كشوفات أعمال المدرسة" — مأخوذة من دليل ملف أعمال المدرسة بالاختبارات
// كل نموذج يُعرّف هنا (النوع + المحتوى) ويُرسَم عبر قالب موحّد حسب النوع.
// الأنواع: committee (قرار تشكيل لجنة) | assignment (تكليف معلم) | tracking (جدول متابعة)
// ============================================================================

export const FORMS = [
  // ---------------------------------------------------------------- نموذج 1
  {
    id: 1,
    num: 1,
    type: "committee",
    name: "قرار تشكيل لجنة التحصيل الدراسي",
    decision: "لجنة التحصيل الدراسي بالمدرسة",
    membersCol: "role", // عمود "الصفة"
    members: [
      { work: "مدير المدرسة", role: "رئيساً" },
      { work: "وكيل الشؤون التعليمية", role: "نائباً للرئيس" },
      { work: "وكيل شؤون الطلاب", role: "عضواً" },
      { work: "الموجه الطلابي", role: "مقرراً" },
      { work: "رائد النشاط", role: "عضواً" },
      { work: "معلم", role: "عضواً" },
      { work: "معلم", role: "عضواً" },
      { work: "معلم", role: "عضواً" },
    ],
    tasks: [
      "تشكيل فرق العمل/ اللجان الفرعية للاختبارات الفترية والنهائية وتحديد مهام ومسؤوليات جميع أعضائها وفقاً للإجراءات المتبعة وفق النماذج رقم ( 2، 3، 4، 5، 6 ).",
      "تكليف المعلمين بإعداد كافة أسئلة الاختبارات، ونماذج الإجابة وتسليمها قبل مواعيد الاختبارات بوقتٍ كافٍ على ألّا يقل عن أسبوعين من بدء الاختبارات النهائية وفق النماذج رقم ( 7، 8 ).",
      "إعداد الملفات المتعلقة بالاختبارات في المدرسة (ملف عام للاختبارات، وملف أعمال الاختبارات الفترية والنهائية، وملفات الاختبارات الشفوية/ العملية).",
      "تهيئة أماكن لجان الاختبارات الشفوية والعملية والمواد ذات الجانبين والتنسيق بين معلمي المواد لوضع الجداول المنظمة لها وإعلانها في وقت مناسب.",
      "إعداد جداول الاختبارات الفترية والنهائية، واختبارات الدور الثاني، والغائبين بعذر، ومواد التعليم المدمج، ومواد التعثر، ومتابعة إدخالها في نظام نور وفق النماذج رقم ( 10، 11، 12 ).",
      "استلام أظرف أوراق الأسئلة والإجابات الخاصة بها، وحفظها في مكان مخصص لها.",
      "إعداد الكشوفات وأرقام الجلوس للطلبة وتسليمها للجنة التحكم والضبط المسؤولة عن عملية تنظيم الاختبارات.",
      "الإشراف على سير الاختبارات بمختلف أنواعها بالمدرسة ومتابعتها، والتأكد من مدى سلامتها وفق النماذج رقم ( 13، 14، 15، 16 ).",
      "متابعة عمليات التصحيح والمراجعة وتدقيق النتائج، ومتابعة أعمال الرصد وإخراج النتائج وتسليمها وحفظها وفق النماذج رقم ( 41، 45 ).",
      "متابعة المستوى التحصيلي للطلبة بشكل دوري وتحليله، ودراسة نتائج الطلبة للعام الدراسي السابق، وإعداد التقارير اللازمة لمناقشتها.",
      "اقتراح برامج معالجة التأخر الدراسي واعتماد الحصص الإضافية لها وتكليف المعلمين وإشعار أولياء الأمور بالبرامج.",
      "إعداد التقارير الدورية عن أعمال اللجنة والمعوقات التي تواجهها وتوثيقها لاتخاذ الإجراء اللازم.",
      "القيام بأي مهام أخرى يتم التكليف بها في مجال اختصاصها.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 2
  {
    id: 2,
    num: 2,
    type: "committee",
    name: "قرار تشكيل لجنة التحكم والضبط",
    decision: "لجنة التحكم والضبط",
    membersCol: "task", // عمود "المهمة"
    members: [
      { work: "وكيل الشؤون المدرسية", role: "رئيساً" },
      { work: "معلم", role: "عضواً" },
      { work: "إداري", role: "عضواً" },
      { work: "إداري", role: "عضواً" },
    ],
    tasks: [
      "تحديد عدد الطلبة في كل لجنة وتحديد غرف اللجان وفق النموذج رقم ( 22 ).",
      "طباعة قوائم بأسماء الطلبة لكل لجنة من نظام نور وفق النموذج رقم ( 23 ).",
      "تثبيت أرقام الجلوس على طاولات الطلبة بحسب نظام التسلسل المعمول به في المدرسة.",
      "التأكد من استبعاد جميع الوسائل التعليمية، وكل ما يتعلق بالمواد الدراسية.",
      "تثبيت اللوحات الإرشادية للدلالة على مقار اللجان.",
      "تزويد كل لجنة بجداول الاختبارات وكشوف بأسماء الطلبة وأرقام جلوسهم.",
      "استلام أوراق الإجابة من الملاحظين على اللجان وفق النموذج رقم ( 39 ).",
      "وضع أوراق الإجابة وصور من الإجابة النموذجية في الظرف الخاص بالمادة.",
      "تسليم مظروف أوراق الإجابة لرئيس لجنة التصحيح والمراجعة وفق النماذج رقم ( 40، 41 ).",
      "حفظ أصول أسئلة الاختبار وأصول الإجابة النموذجية في ملف خاص بالمدرسة.",
      "استلام أوراق الإجابة بعد الانتهاء من الرصد والمطابقة من لجنة التصحيح والمراجعة وفق النموذج رقم ( 41 ).",
      "حفظ كشوف الرصد النهائية مكتملة التوقيعات من الراصد والمملي والمراجع في الملفات الخاصة بذلك.",
      "حفظ أوراق الإجابة في المكان المخصص لذلك.",
      "مطابقة درجات الكشف مع درجات أوراق الإجابة.",
      "المصادقة والتوقيع على كشوف الرصد.",
      "القيام بأي مهام أخرى يتم التكليف بها في مجال اختصاصها.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 3
  {
    id: 3,
    num: 3,
    type: "committee",
    name: "قرار تشكيل لجنة الإشراف والملاحظة",
    decision: "لجنة الإشراف والملاحظة",
    membersCol: "task",
    members: [
      { work: "وكيل شؤون الطلاب", role: "رئيساً" },
      { work: "معلم", role: "عضواً" },
      { work: "إداري", role: "عضواً" },
      { work: "إداري", role: "عضواً" },
    ],
    tasks: [
      "إعداد الجداول الخاصة بالملاحظين والإشراف اليومي وفق النموذج رقم ( 24 ).",
      "متابعة توقيع الملاحظين على نموذج سجل الملاحظين اليومي وفق النموذج رقم ( 25 ).",
      "تأمين الملاحظ البديل عند تأخر أو غياب أحد الملاحظين قبل بدء الاختبار وفق النموذج رقم ( 26 ).",
      "فتح مظاريف الأسئلة والتأكد من سلامتها وفق النموذج رقم ( 27 ).",
      "متابعة دخول الطلاب للجان الاختبار.",
      "فرز الأسئلة حسب توزيع اللجان، وتسليمها للمشرفين على قاعات الاختبار.",
      "إعداد محضر رسمي عند الإخلال بسرية الأسئلة، وسير الاختبارات وفق النماذج رقم ( 28، 29 ).",
      "متابعة سير الاختبارات وحضور الطلبة وخروجهم في أثناء الاختبارات.",
      "التعامل مع الطلبة المتأخرين عن الاختبار حسب زمن حضورهم وفق النماذج رقم ( 30، 31، 32، 33 ).",
      "التعامل مع الحالات المخالفة للأنظمة والتعليمات وفق النموذج رقم ( 34 ).",
      "متابعة غياب الطلبة أثناء الاختبارات، وحصر الطلبة الغائبين وفق النماذج رقم ( 35، 36، 37 ).",
      "توزيع كشوف تسليم أوراق الإجابة (كشوف المناداة) على مشرفي اللجان بعد انقضاء نصف زمن الاختبار وفق النموذج رقم ( 38 ).",
      "القيام بأي مهام أخرى يتم التكليف بها في مجال اختصاصها.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 4
  {
    id: 4,
    num: 4,
    type: "committee",
    name: "قرار تشكيل لجنة التصحيح والمراجعة",
    decision: "لجنة التصحيح والمراجعة",
    membersCol: "task",
    members: [
      { work: "وكيل الشؤون التعليمية", role: "رئيساً" },
      { work: "معلم", role: "عضواً" },
      { work: "إداري", role: "عضواً" },
    ],
    tasks: [
      "استلام رئيس لجنة التصحيح والمراجعة أوراق إجابات الطلبة مع صور من نماذج الإجابة من لجنة التحكم والضبط وفق النموذج رقم ( 41 )، وتسليمها للجان التصحيح وفقاً للتخصص.",
      "تحديد أسماء وتواقيع المصححين والمراجعين والمدققين لكل مادة دراسية وفق النموذج رقم ( 42 ).",
      "في حالة اكتشاف خطأ في الأسئلة، أو في الإجابة النموذجية يتم إعداد محضر بذلك مضمناً الإجراء المتخذ وفق النماذج رقم ( 43، 44 ).",
      "تدقيق عملية التصحيح، وتدقيق عملية الرصد وفق النموذج رقم ( 45 ).",
      "مطابقة درجات الكشف المستخرج من نظام نور مع درجات أوراق الإجابة.",
      "المصادقة والتوقيع على كشوف الرصد المستخرجة من نظام نور.",
      "تسليم أوراق الإجابة بعد الانتهاء من الرصد والمطابقة للجنة التحكم والضبط مع كشوف الرصد وفق النموذج رقم ( 41 ).",
      "تطبيق ضوابط التصحيح الآلي في أعمال الاختبارات (للمدارس المطبقة) وفق التعميم المنظم لذلك.",
      "القيام بأي مهام أخرى يتم التكليف بها في مجال اختصاصها.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 5
  {
    id: 5,
    num: 5,
    type: "committee",
    name: "قرار تشكيل لجنة الرصد وإخراج النتائج",
    decision: "لجنة الرصد وإخراج النتائج",
    membersCol: "task",
    members: [
      { work: "وكيل الشؤون التعليمية", role: "رئيساً" },
      { work: "إداري", role: "عضواً" },
      { work: "معلم كل مادة دراسية", role: "عضواً" },
    ],
    tasks: [
      "التأكد من رصد جميع الدرجات المستحقة للطلبة في نظام نور قبل بدء اختبارات نهاية الفصل الدراسي.",
      "تطبيق ضوابط التصحيح الآلي في أعمال الاختبارات (للمدارس المطبقة) وفق التعميم المنظم لذلك.",
      "يرصد المعلم درجات مادته في نظام نور من أوراق إجابات الطلبة بعد الانتهاء من عملية التصحيح مباشرة، ويراجعها بنفسه، ثم يُطبع كشف أولي يُرفق مع أوراق الإجابات، ويسلم إلى لجنة التصحيح والمراجعة.",
      "استخراج النتيجة الأولية من نظام نور.",
      "تطبيق قواعد المراجعة النهائية للطلبة المستحقين للمراجعة النهائية وفق شروط لائحة تقويم الطالب.",
      "إغلاق رصد الدرجات في نظام نور، ونشر كشوف الدرجات على نظام نور.",
      "إدخال جداول الدور الثاني في نظام نور.",
      "استخراج كشوف الطلبة المكملين، وتسليم الطالب المكمل إشعاراً بمواد الإكمال، وموعد اختبار الدور الثاني.",
      "استخراج كشوف الطلبة الراسبين، وتسليم الطالب الراسب إشعار الرسوب.",
      "إعلان النتيجة وتسليم كشوف الدرجات.",
      "إعداد سجلات النتيجة النهائية (المبيضة) للمدرسة بعد إعلان نتيجة الدور الثاني وفق النموذج رقم ( 50 ).",
      "القيام بأي مهام أخرى يتم التكليف بها في مجال اختصاصها.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 6
  {
    id: 6,
    num: 6,
    type: "committee",
    name: "قرار تشكيل لجان التصحيح والمراجعة وفقاً للتخصص",
    decision: "لجنة تصحيح مادة",
    subjectLine: true, // يضيف سطر "مادة: ... ومقرها: ..."
    membersCol: "none",
    membersHeader: "أعضاء اللجنة",
    members: [
      { work: "", role: "رئيساً" },
      { work: "", role: "عضواً" },
      { work: "", role: "عضواً" },
      { work: "", role: "عضواً" },
    ],
    tasksTitle: "تعليمات التصحيح والمراجعة:",
    tasks: [
      "على مدير المدرسة أو من ينوب عنه إعداد كشوف بأسماء وتواقيع المصححين والمراجعين والمدققين وفق النموذج رقم ( 42 ).",
      "يكون تقدير الدرجات طبقاً لنماذج الإجابة.",
      "يمنع فتح أظرف نماذج الإجابة إلا بعد التأكد من استلام جميع أوراق الإجابة من الطلبة.",
      "تُصحح أوراق إجابات الطلبة أولاً بأول بالمدرسة في المكان المخصص لذلك، ويتم التصحيح بالقلم الأحمر والمراجعة والتدقيق بلون مغاير (الأسود).",
      "عند قيام الطالب بشطب إجابته الصحيحة وتدوين إجابة خاطئة فإن كان مكملاً فتصحح له في حال وضوحها ويعطى بموجبها نصف الدرجة المستحقة.",
      "توضع إشارة ( × ) على السؤال المتروك في حقل درجة السؤال وتدون كلمة (متروك) في حقل الكتابة.",
      "يقوم المعلم بتسليم المسؤول أوراق الإجابة متسلسلة بعد الانتهاء من تصحيحها ومراجعتها، ويقوم المسؤول بالتوقيع على الكشوف المخصصة لتسليم أوراق الإجابة وفق النموذج رقم ( 41 ).",
      "تفحص أوراق الإجابة للتأكد من أن جميع الإجابات قد قُدّرت وروجعت ودُققت مع كتابة الأسماء صريحة للمصححين والمراجعين والمدققين.",
      "تطبيق ضوابط التصحيح الآلي في أعمال الاختبارات (للمدارس المطبقة) وفق التعميم المنظم لذلك.",
      "عدم القيام بتصوير إجابات الطلبة أو أجزاء منها بأي وسيلة كانت إلا للدواعي الرسمية كالتحقيق وما شابه ذلك.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 7
  {
    id: 7,
    num: 7,
    type: "assignment",
    name: "قرار تكليف معلم بإعداد أسئلة اختبار مادة ونماذج الإجابة وتصويرها وتغليفها",
    tasks: [
      "العمل وفق ما ورد في الفصل (الثاني، والثالث، والرابع) من أنظمة وإجراءات الاختبارات.",
      "يراعى عند إعداد أسئلة ونماذج الإجابة للمواد ذات الجانبين توزيع الدرجات المختلف الوارد في دليل توزيع درجات المواد الدراسية وفق لائحة تقويم الطالب.",
      "أهداف المرحلة التعليمية والمادة الدراسية التي يجرى تقويمها، وتطبيق جدول مواصفات كل مادة.",
      "قياس الأسئلة للمستويات العقلية العليا من فهم وتطبيق وتحليل وتركيب وتقويم لتحقيق تقويم شامل.",
      "شمول الأسئلة لوحدات المقرر الدراسي بشكل متوازن مع مراعاة التنوع، والمزاوجة بين الأسئلة المقالية والموضوعية.",
      "صياغة الأسئلة بلغة واضحة سليمة خالية من الأخطاء اللغوية والإملائية والمطبعية.",
      "إعداد مفتاح لتصحيح الاختبار يتضمن كتابة الإجابة النموذجية والمقبولة، وتوزيع الدرجات المستحقة عليها.",
      "الالتزام بأهمية المحافظة على سرية الأسئلة وعدم إفشائها أو التلميح بها بأي طريقة كانت.",
      "الاهتمام بورقة الأسئلة من حيث الإخراج وتنظيم البيانات الخاصة برأس الصفحة وفق النموذج رقم ( 9 ).",
      "التأكد من كتابة أسماء معدي الأسئلة وتواقيعهم في آخر ورقة من نموذج الإجابة، ويمنع طباعة الأسئلة خارج المدرسة.",
      "يتم تصوير الأسئلة (داخل المدرسة) من قبل معدها وتُظرف في ظروف رسمية مع أصول الأسئلة ونماذج الإجابة وفق النماذج رقم ( 19، 20، 21 ).",
    ],
  },
  // ---------------------------------------------------------------- نموذج 8
  {
    id: 8,
    num: 8,
    type: "tracking",
    name: "متابعة تسليم واستلام أسئلة ونماذج الإجابة وتصويرها وتغليفها",
    columns: [
      "اسم المعلم",
      "المادة",
      "الصف / المستوى",
      "المسار",
      "تاريخ استلام قرار التكليف",
      "توقيع المعلم",
      "مظروف أصل الأسئلة",
      "مظروف أصل الإجابة",
      "مظاريف أسئلة الطلاب",
      "تاريخ التسليم",
      "التوقيع",
      "ملاحظات",
    ],
    fromTeachers: true, // يملأ "اسم المعلم" من قائمة المعلمين
    rows: 15,
  },
  // ---------------------------------------------------------------- نموذج 19
  {
    id: 19,
    num: 19,
    type: "envelope",
    name: "ظرف أصل الأسئلة",
    fields: [
      { label: "العام الدراسي", bind: "hyear" },
      { label: "الفصل الدراسي", options: ["الأول", "الثاني"] },
      { label: "الدور", options: ["الأول", "الثاني"] },
      { label: "الأسئلة", options: ["الأساسية", "البديلة"] },
      { label: "المادة" },
      { label: "الصف / المستوى" },
      { label: "المسار" },
      { label: "اسم المعلم", src: "teacher" },
      { label: "توقيع المعلم" },
    ],
  },
  // ---------------------------------------------------------------- نموذج 20
  {
    id: 20,
    num: 20,
    type: "envelope",
    name: "ظرف أصل الإجابة النموذجية",
    fields: [
      { label: "العام الدراسي", bind: "hyear" },
      { label: "الفصل الدراسي", options: ["الأول", "الثاني", "كل الفصول"] },
      { label: "الدور", options: ["الأول", "الثاني"] },
      { label: "الأسئلة", options: ["الأساسية", "البديلة"] },
      { label: "المادة" },
      { label: "الصف / المستوى" },
      { label: "المسار" },
      { label: "اسم المعلم", src: "teacher" },
      { label: "توقيع المعلم" },
    ],
  },
  // ---------------------------------------------------------------- نموذج 21
  {
    id: 21,
    num: 21,
    type: "envelope",
    name: "ظرف أسئلة الطلبة",
    fields: [
      { label: "العام الدراسي", bind: "hyear" },
      { label: "الفصل الدراسي" },
      { label: "الدور" },
      { label: "المادة" },
      { label: "الصف / المستوى" },
      { label: "المسار" },
      { label: "اليوم" },
      { label: "التاريخ" },
      { label: "الفترة" },
      { label: "رقم اللجنة" },
      { label: "عدد طلبة اللجنة" },
    ],
  },
  // ---------------------------------------------------------------- نموذج 40
  {
    id: 40,
    num: 40,
    type: "envelope",
    name: "ظرف أوراق إجابات الطلبة",
    fields: [
      { label: "العام الدراسي", bind: "hyear" },
      { label: "الفصل الدراسي" },
      { label: "الدور" },
      { label: "المادة" },
      { label: "الصف / المستوى" },
      { label: "المسار" },
      { label: "اليوم" },
      { label: "التاريخ" },
      { label: "الفترة" },
      { label: "عدد ظروف المادة" },
      { label: "ظرف المادة رقم" },
      { label: "عدد اللجان" },
      { label: "عدد المتقدمين" },
      { label: "عدد الحاضرين" },
      { label: "عدد الغائبين" },
      { label: "المجموع" },
    ],
  },

  // ====================== بطاقات المتابعة (card) ======================
  // ---------------------------------------------------------------- نموذج 13
  {
    id: 13,
    num: 13,
    type: "card",
    variant: "checklist",
    name: "بطاقة تأمين الاحتياجات والإمكانيات اللازمة للاختبارات",
    items: [
      "تخصيص مكان آمن خاص لإدارة أعمال الاختبارات ولا يُستخدم لأي غرض آخر.",
      "تأمين ماكينة تصوير جيدة والتأكد من سلامتها للعمل.",
      "توفير الكمية المطلوبة مسبقاً من أحبار وجميع مستلزمات ماكينة التصوير.",
      "تأمين ورق تصوير حسب المقاس المطلوب بالعدد الكافي للأسئلة والنماذج التنظيمية.",
      "تأمين ظروف (مقاسات مختلفة) لوضع الأسئلة وللإجابة النموذجية ولأوراق إجابات الطلاب.",
      "تأمين وحدة تخزين خارجية لحفظ البيانات من نظام نور.",
      "تأمين عدد كافٍ من الدباسات وأقلام ذات خط كبير ولاصق للظروف.",
      "تأمين أوراق لاصقة خاصة بأرقام الجلوس حسب المقاس المطلوب من نظام نور.",
      "تأمين أقلام زرقاء للطلبة، وحمراء للتصحيح، وسوداء للمراجعة الأولية، وخضراء للمراجعة النهائية.",
      "إعداد ملف عام للاختبارات وتحديثه بصفة مستمرة بما يستجد من التعاميم واللوائح والأدلة.",
      "إعداد ملف مخصص لأعمال الاختبارات الفترية والنهائية يتضمن جميع الأعمال والنماذج المستخدمة.",
      "إعداد ملفات خاصة للاختبارات الشفوية/ العملية.",
      "إعداد ملفات لوضع أصل الأسئلة وأصل الإجابة النموذجية لكل صف على حدة لحفظها بالمدرسة.",
      "إعداد ملف لوضع صور الأسئلة مع صور الإجابة النموذجية لإرسالها لمكتب التعليم بعد الاختبارات.",
      "طباعة نموذج معلومات ظروف الأسئلة وظروف إجابات الطلبة أو تصوير النموذج ولصقه بالظرف.",
      "تصوير نماذج تنظيم الاختبارات بالعدد المطلوب وتوزيعها على لجان الاختبارات الفرعية.",
      "بيان بأسماء الطلبة وهواتف أولياء أمورهم.",
      "توفير الإسعافات الأولية وتهيئة المكان المناسب للحالات الصحية أو الطارئة للطلبة.",
      "توفير الماء البارد لجميع اللجان وبالطريقة المناسبة لكل مدرسة.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 14
  {
    id: 14,
    num: 14,
    type: "card",
    variant: "checklist",
    name: "بطاقة متابعة الاستعدادات قبل الاختبارات",
    items: [
      "إصدار قرار تشكيل لجنة التحصيل الدراسي وفق النموذج رقم ( 1 ).",
      "الاجتماع بلجنة التحصيل الدراسي.",
      "إصدار قرارات تشكيل لجان الاختبارات الفرعية وفق النماذج رقم ( 2، 3، 4، 5، 6 ).",
      "إعداد كشف بأسماء معدي الأسئلة والمصححين والمراجعين لكل مادة دراسية.",
      "إصدار قرار تكليف المعلمين بإعداد الأسئلة للاختبارات وفق النموذج رقم ( 7 ).",
      "استلام أسئلة المواد من المعلمين بعد تصويرها وتغليفها وحفظها وفق النموذج رقم ( 8 ).",
      "إعداد جداول الاختبارات لجميع الصفوف وإعلانها وفق النماذج رقم ( 10، 11، 12 ).",
      "التأكد من اكتمال تأمين الاحتياجات والإمكانيات اللازمة وفق النموذج رقم ( 13 ).",
      "الحصول على موافقة استخدام التصحيح الآلي في أعمال الاختبارات (للمدارس المطبقة).",
      "تدقيق بيانات الطلبة في نظام نور ومطابقتها مع وثائقهم الرسمية من بداية العام الدراسي.",
      "أخذ إقرارات معلمي المواد بإنهاء المقررات الدراسية في وقتها المحدد وفق النموذج رقم ( 17 ).",
      "متابعة تسليم المعلمين لسجلات متابعة تقويم الطلبة نهاية كل فصل دراسي وفق النموذج رقم ( 18 ).",
      "إصدار تعميم للمعلمين بأهمية الاحتفاظ بكل ما يتعلق بالطلبة.",
      "تجهيز ظروف الأسئلة والإجابات مدوّنة بها المعلومات وفق النماذج رقم ( 19، 20، 21 ).",
      "متابعة رصد درجات الطلبة لجميع اختبارات الفترة التقويمية وأعمال السنة.",
      "متابعة مطابقة المعلمين كشوف اختبارات الفترة التقويمية وأعمال السنة بعد رصدها في نظام نور.",
      "متابعة رصد درجات مواد التقويم التكويني والمواد ذات الجانبين.",
      "متابعة مطابقة المعلمين درجات مواد التقويم التكويني والمواد ذات الجانبين بعد رصدها.",
      "متابعة رصد درجات السلوك والمواظبة.",
      "مطابقة درجات السلوك والمواظبة.",
      "عمل بيان باللجان وأماكنها وأعداد الطلاب لكل لجنة وفق النموذج رقم ( 22 ).",
      "إعداد توزيع الطلبة على اللجان (أبجدياً) في نظام نور.",
      "طباعة كشف أسماء طلبة اللجان من نظام نور وفق النموذج رقم ( 23 ).",
      "وضع كشف أسماء طلبة اللجنة وأرقام جلوسهم على مدخل مقر اللجنة وفي فناء المدرسة.",
      "تهيئة مقار لجان الاختبار.",
      "تجهيز مقاعد الطلبة وفق العدد المحدد للجان ووضع أرقام الجلوس عليها مرتبة تصاعدياً.",
      "تجهيز مقار اللجان التنظيمية العاملة.",
      "تجهيز أماكن حفظ أوراق إجابات الطلبة.",
      "إعداد الجدول العام لتوزيع الملاحظين على اللجان وفق النموذج رقم ( 24 ).",
      "تفريغ أسماء الملاحظين على نموذج الملاحظة اليومية وفق النموذج رقم ( 25 ).",
      "تطبيق ضوابط انتساب غير السعوديين.",
      "الاجتماع العام بجميع العاملين بالمدرسة.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 15
  {
    id: 15,
    num: 15,
    type: "card",
    variant: "days",
    name: "بطاقة متابعة الأعمال أثناء الاختبارات",
    days: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس"],
    items: [
      "متابعة دخول الطلبة لفناء المدرسة ثم مقار اللجان.",
      "متابعة حضور المعلمين للمدرسة.",
      "متابعة توقيع المعلمين على كشف الملاحظة اليومي.",
      "التأكد من وجود جميع الملاحظين في اللجان قبل دخول الطلبة.",
      "قيام لجنة الإشراف والملاحظة بفتح ظروف الأسئلة قبل الاختبار بـ15 دقيقة وفق النموذج رقم ( 27 ).",
      "تسليم مظاريف أسئلة الاختبار للملاحظين قبل الاختبار بـ5 دقائق.",
      "إعلان بدء الاختبار وتوزيع الأسئلة على الطلاب.",
      "التأكد من استلام جميع الطلبة أسئلة المادة كاملة وبشكل واضح.",
      "تدوين أسماء الطلبة المتأخرين عن الاختبار وفق النماذج رقم ( 30، 31، 32، 33 ).",
      "حصر الطلبة الغائبين والاتصال هاتفياً على أولياء أمورهم.",
      "متابعة حضور الطلبة الغائبين وتدوين من تأكد غيابهم وفق النماذج رقم ( 35، 36، 37 ).",
      "تفقد رئيس لجنة الاختبارات ورؤساء اللجان الفرعية قاعات الاختبارات.",
      "توزيع كشف تسليم أوراق الإجابة (كشوف المناداة) بعد نصف زمن الاختبار وفق النموذج رقم ( 38 ).",
      "استلام لجنة التحكم والضبط أوراق إجابات الطلبة من الملاحظين وفق النماذج رقم ( 39، 40، 41 ).",
      "تسليم ظروف المواد من رئيس لجنة التحكم والضبط لرئيس لجنة التصحيح والمراجعة وفق النموذج ( 41 ).",
      "متابعة تفعيل النموذج رقم ( 42 ) الخاص بتحديد أسماء المصححين والمراجعين والمدققين.",
      "متابعة تطبيق ضوابط التصحيح الآلي في أعمال الاختبارات.",
      "رصد المعلم درجات مادته في نظام نور من أوراق إجابات الطلبة مباشرة ومراجعتها بنفسه.",
      "الاطلاع على أعمال لجان التصحيح والمراجعة والتدقيق بأخذ عينة عشوائية من أوراق الإجابات.",
      "استلام لجنة التحكم والضبط أوراق الإجابات منتهية التصحيح والمراجعة والرصد وفق النموذج ( 41 ).",
      "متابعة سير أوراق الإجابة وفق النموذج رقم ( 41 ).",
      "إعلام جميع الطلاب بموعد الاستعلام عن النتائج النهائية من نظام نور.",
    ],
  },
  // ---------------------------------------------------------------- نموذج 16
  {
    id: 16,
    num: 16,
    type: "card",
    variant: "checklist",
    name: "بطاقة متابعة الأعمال بعد الاختبارات",
    items: [
      "استخراج بيانات المراجعة النهائية من نظام نور.",
      "تدقيق النتائج واعتمادها وفق أنظمة وإجراءات الاختبارات.",
      "إغلاق الدرجات واعتمادها في نظام نور حسب تعميم الخطة الزمنية.",
      "طباعة إشعارات الفصل الدراسي من نظام نور وحفظ نسخة إلكترونية بصيغة pdf.",
      "طباعة الشهادات من نظام نور.",
      "توقيع شهادات الطلبة الناجحين وختمها.",
      "طباعة أسماء الطلبة الناجحين من نظام نور.",
      "طباعة أسماء الطلبة الأوائل (المتفوقين) لكل صف من نظام نور.",
      "إدخال جدول الدور الثاني في نظام نور وطباعته وحفظ نسخة منه في المدرسة.",
      "طباعة إشعارات الطلبة المكملين (صورتين) من نظام نور وتوقيعها وختمها.",
      "تسليم الطلبة المكملين إشعارات الإكمال وأخذ توقيعاتهم عليها.",
      "حفظ شهادات الطلبة على الحاسب الآلي بصيغة pdf في وحدة تخزين خارجية.",
      "طباعة إحصائيات الاختبار لجميع الصفوف.",
      "إعداد خطة اختبارات الدور الثاني.",
      "طباعة أسماء الطلبة المكملين لكل مادة وفي كل مقرر دراسي.",
      "طباعة أسماء الطلبة المتعثرين في نظام المسارات ومواد تعثرهم.",
      "التأكد من استلام جميع أسئلة الدور الثاني وبديلة/ مواد التعثر.",
      "إعداد جداول المتغيبين بعذر عن اختبارات الفصل الدراسي وإعلانها.",
      "إعداد جداول المتغيبين بعذر عن اختبارات الدور الثاني وإعلانها.",
      "إعداد جداول المتعثرين في نظام المسارات وإعلانها.",
      "طباعة إشعارات الطلبة الراسبين (صورتين) من نظام نور.",
      "تسليم الطلبة الراسبين إشعارات الرسوب وأخذ توقيعاتهم عليها.",
      "طباعة مبيضة نتائج الطلبة وتغليفها والاحتفاظ بها في خزانة المدرسة.",
      "تزويد مكتب التعليم بنسخة من أسئلة الاختبار والإجابة النموذجية لجميع المواد الدراسية.",
    ],
  },

  // ====================== المحاضر (minutes) ======================
  // ---------------------------------------------------------------- نموذج 26
  {
    id: 26,
    num: 26,
    type: "minutes",
    name: "محضر دخول معلم ملاحظ بديل",
    blocks: [
      { b: "info", fields: [{ label: "اليوم" }, { label: "التاريخ" }, { label: "الفترة" }] },
      {
        b: "info",
        fields: [
          { label: "المعلم الملاحظ (احتياط)", src: "teacher" },
          { label: "لدخول لجنة اختبار رقم" },
          { label: "ومقرها" },
          { label: "بديلاً عن المعلم الملاحظ (أساسي)", src: "teacher" },
          { label: "وذلك بسبب" },
        ],
      },
      {
        b: "signs",
        label: "لجنة الإشراف والملاحظة:",
        items: [{ role: "رئيس اللجنة" }, { role: "عضو" }, { role: "المعلم الملاحظ البديل" }],
      },
      { b: "boss" },
      { b: "note", text: "يحفظ بملف أعمال الاختبارات." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 27
  {
    id: 27,
    num: 27,
    type: "minutes",
    name: "محضر فتح مظروف أسئلة",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اليوم" },
          { label: "التاريخ" },
          { label: "الفترة" },
          { label: "المادة" },
          { label: "الصف / المستوى" },
        ],
      },
      {
        b: "para",
        text: "تم فتح مظروف الأسئلة عند الساعة (......) وتم تحرير محضر بذلك، ووجد:",
      },
      { b: "checks", label: "حالة المظروف:", options: ["سليم", "غير سليم"] },
      {
        b: "members",
        header: "أعضاء اللجنة",
        mode: "committee",
        rows: [
          { work: "وكيل شؤون الطلاب", role: "رئيساً" },
          { work: "وكيل الشؤون التعليمية", role: "عضواً" },
          { work: "معلم", role: "عضواً" },
          { work: "معلم", role: "عضواً" },
        ],
      },
      { b: "note", text: "تفتح مظاريف الأسئلة قبل بدء الاختبار بـ (15) دقيقة." },
      { b: "note", text: "يمنع فتح أظرف نماذج الإجابة إلا بعد التأكد من استلام جميع أوراق الإجابة من الطلبة." },
      { b: "note", text: "يحفظ بملف أعمال الاختبارات." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 28
  {
    id: 28,
    num: 28,
    type: "minutes",
    name: "محضر الإخلال بسرية الأسئلة",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اليوم" },
          { label: "التاريخ" },
          { label: "مادة" },
          { label: "للصف / المستوى" },
        ],
      },
      { b: "lines", label: "أولاً: وصف الخلل:", n: 2 },
      { b: "lines", label: "وقد تبين لنا ذلك من خلال:", n: 2 },
      { b: "signs", label: "لجنة الإشراف والملاحظة:", items: [{ role: "رئيس اللجنة" }, { role: "عضواً" }, { role: "عضواً" }] },
      { b: "lines", label: "ثانياً: عليه تم اتخاذ الإجراءات التالية:", n: 2 },
      { b: "signs", label: "لجنة التحصيل الدراسي:", items: [{ role: "" }, { role: "" }, { role: "" }] },
      { b: "boss" },
      { b: "note", text: "تحفظ بملف أعمال الاختبارات، وصورة فورية لمكتب التعليم." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 29
  {
    id: 29,
    num: 29,
    type: "minutes",
    name: "محضر الإخلال بسير الاختبارات",
    blocks: [
      { b: "info", fields: [{ label: "اليوم" }, { label: "التاريخ" }] },
      { b: "lines", label: "أولاً: وصف الخلل:", n: 2 },
      { b: "lines", label: "وقد تبين لنا ذلك من خلال:", n: 2 },
      { b: "signs", label: "لجنة الإشراف والملاحظة:", items: [{ role: "رئيس اللجنة" }, { role: "عضواً" }, { role: "عضواً" }] },
      { b: "lines", label: "ثانياً: عليه تم اتخاذ الإجراءات التالية:", n: 2 },
      { b: "signs", label: "لجنة التحصيل الدراسي:", items: [{ role: "" }, { role: "" }, { role: "" }] },
      { b: "boss" },
      { b: "note", text: "تحفظ بملف أعمال الاختبارات، وصورة فورية لمكتب التعليم." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 34
  {
    id: 34,
    num: 34,
    type: "minutes",
    name: "محضر مخالفة الأنظمة والتعليمات",
    blocks: [
      { b: "info", fields: [{ label: "اليوم" }, { label: "التاريخ" }, { label: "الفترة" }, { label: "المادة" }] },
      {
        b: "members",
        header: "بيانات الطالب:",
        mode: "student",
        rows: [{ name: "", seat: "", class: "" }],
      },
      { b: "checks", label: "تكرار المخالفة:", options: ["المرة الأولى", "المرة الثانية", "المرة الثالثة"] },
      { b: "checks", label: "وصف المخالفة:", options: ["فردي", "جماعي"] },
      { b: "lines", label: "تفاصيل المخالفة:", n: 2 },
      { b: "lines", label: "الإجراءات المتخذة:", n: 2 },
      { b: "signs", label: "المصادقة:", items: [{ role: "" }, { role: "" }, { role: "" }] },
      { b: "boss" },
      { b: "note", text: "يحفظ بملف أعمال الاختبارات." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 35
  {
    id: 35,
    num: 35,
    type: "minutes",
    name: "محضر غياب طالب عن الاختبار",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اسم الطالب", src: "student" },
          { label: "رقم الجلوس" },
          { label: "اليوم" },
          { label: "التاريخ" },
          { label: "الفترة" },
          { label: "اللجنة" },
          { label: "المادة" },
          { label: "الصف / المستوى" },
        ],
      },
      {
        b: "signs",
        label: "المصادقة:",
        items: [
          { role: "رئيس لجنة الإشراف والملاحظة" },
          { role: "عضو لجنة الإشراف والملاحظة" },
          { role: "ملاحظ اللجنة" },
        ],
      },
      { b: "boss" },
      { b: "note", text: "يوضع محضر الغياب حسب رقم جلوس الطالب في تسلسل أوراق الإجابة، ويسجل في بيان الغائبين." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 30
  {
    id: 30,
    num: 30,
    type: "minutes",
    name: "تعهد طالب تأخر عن الاختبار بما لا يتجاوز خمس عشرة دقيقة",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اسم الطالب", src: "student" },
          { label: "الصف / المستوى" },
          { label: "المسار" },
          { label: "اليوم" },
          { label: "التاريخ" },
          { label: "الفترة" },
          { label: "المادة" },
          { label: "وقت بدء الاختبار" },
          { label: "وقت حضور الطالب" },
          { label: "مقدار التأخر" },
        ],
      },
      {
        b: "para",
        text:
          "أتعهد أنا الطالب المذكور أعلاه بالالتزام بالحضور المبكر أيام الاختبارات وعدم تكرار التأخر، وأُشعرت أنه في حال التكرار يتم حسم درجة من درجات المواظبة عن كل تأخر، وعلى ذلك أوقع.",
      },
      { b: "signs", items: [{ role: "رئيس لجنة الإشراف والملاحظة" }, { role: "رئيس لجنة التحكم والضبط" }] },
      { b: "note", text: "يسجل في بيان المتأخرين، ويحفظ بملف أعمال الاختبارات." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 32
  {
    id: 32,
    num: 32,
    type: "minutes",
    name: "محضر تأخر طالب عن الاختبار أكثر من خمس عشرة دقيقة / تكرار تأخر",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اسم الطالب", src: "student" },
          { label: "رقم الهوية" },
          { label: "عدد مرات التأخير" },
          { label: "الصف / المستوى" },
          { label: "المسار" },
          { label: "اليوم" },
          { label: "التاريخ" },
          { label: "الفترة" },
          { label: "المادة" },
          { label: "وقت بدء الاختبار" },
          { label: "وقت حضور الطالب" },
          { label: "مقدار التأخر" },
          { label: "اسم الملاحظ", src: "teacher" },
        ],
      },
      { b: "lines", label: "أسباب التأخر/ تكرار التأخر حسب إفادة الطالب/ ولي أمره/ أوراق رسمية:", n: 2 },
      {
        b: "checks",
        label: "بعد دراسة الأسباب تقرر ما يلي:",
        options: [
          "قبول عذر الطالب ويدخل الاختبار",
          "عدم قبول عذر الطالب ولا يدخل الاختبار",
          "يحسم على الطالب درجة من درجات السلوك",
          "إجراء آخر",
        ],
      },
      {
        b: "signs",
        items: [
          { role: "رئيس لجنة الإشراف والملاحظة" },
          { role: "رئيس لجنة التحكم والضبط" },
          { role: "اعتماد مدير المدرسة" },
        ],
      },
      { b: "note", text: "يسجل في بيان المتأخرين، ويحفظ بملف أعمال الاختبارات." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 46
  {
    id: 46,
    num: 46,
    type: "minutes",
    name: "طلب مراجعة ورقة طالب",
    blocks: [
      {
        b: "info",
        fields: [
          { label: "اسم الطالب", src: "student" },
          { label: "رقم الهوية" },
          { label: "الصف / المستوى" },
          { label: "اسم مقدم الطلب" },
          { label: "تاريخ الطلب" },
        ],
      },
      {
        b: "para",
        text:
          "المكرم / رئيس لجنة الرصد وإخراج النتائج، السلام عليكم ورحمة الله وبركاته، آمل التكرم بمراجعة أوراق الطالب المذكور أعلاه حسب المواد الموضحة أدناه وتسجيل نتيجة المراجعة.",
      },
      {
        b: "members",
        header: "المواد المطلوب مراجعتها:",
        mode: "subjects",
        rows: [{ subject: "" }, { subject: "" }, { subject: "" }],
      },
      { b: "boss" },
      { b: "note", text: "يحفظ الأصل في ملف الطالب، وصورة لولي أمر الطالب." },
    ],
  },
  // ---------------------------------------------------------------- نموذج 49
  {
    id: 49,
    num: 49,
    type: "minutes",
    name: "طلب رصد درجة طالب غائب عن اختبار نهاية الفصل/ الدور الثاني بعذر في نظام نور",
    blocks: [
      {
        b: "para",
        text:
          "المكرم/ مدير إدارة تقويم التحصيل المعرفي والمهاري وفقه الله، السلام عليكم ورحمة الله وبركاته، تجدون برفقه بيان بدرجات الطلاب الغائبين بعذر مقبول عن الاختبار، ونأمل إتاحة فتح إدخال الدرجات في نظام نور حسب الصفوف المحددة أدناه.",
      },
      { b: "signs", items: [{ role: "مدير المدرسة" }] },
      {
        b: "members",
        header: "بيان الطلاب:",
        mode: "grades",
        rows: [{ name: "" }, { name: "" }, { name: "" }],
      },
      { b: "note", text: "يتم التعديل بمشاركة المعلم المختص، ويحفظ بملف أعمال الاختبارات." },
    ],
  },

  // ====================== جداول (tracking) ======================
  // ---------------------------------------------------------------- نموذج 33
  {
    id: 33,
    num: 33,
    type: "tracking",
    name: "بيان بأسماء الطلبة المتأخرين عن الاختبار",
    columns: [
      "اسم الطالب",
      "الصف / المستوى",
      "المسار",
      "اليوم",
      "التاريخ",
      "الفترة",
      "المادة",
      "مقدار التأخر",
      "إيضاحات",
    ],
    colSrc: { 0: "student" },
    rows: 18,
  },
  // ---------------------------------------------------------------- نموذج 47
  {
    id: 47,
    num: 47,
    type: "tracking",
    name: "تعديل درجة طالب في نظام نور (قبل إغلاق الدرجات)",
    columns: [
      "المادة",
      "اسم الطالب",
      "الصف / المستوى",
      "المسار",
      "الدرجة قبل التعديل",
      "الدرجة بعد التعديل",
      "سبب التعديل",
      "تاريخ التعديل",
      "التوقيع",
    ],
    colSrc: { 1: "student" },
    rows: 8,
  },
  // ---------------------------------------------------------------- نموذج 48
  {
    id: 48,
    num: 48,
    type: "tracking",
    name: "تعديل درجة طالب في نظام نور (بعد إغلاق الدرجات)",
    columns: [
      "اسم الطالب رباعياً",
      "رقم الهوية",
      "الصف / المستوى",
      "المادة",
      "الدرجة المرصودة",
      "الدرجة المستحقة",
      "سبب التعديل",
    ],
    colSrc: { 0: "student" },
    rows: 8,
  },
];

export function getForm(id) {
  return FORMS.find((f) => String(f.id) === String(id));
}
